module.exports = __webpack_public_path__ + "static/img/3.736f3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-de-mascotas/3.png
// module id = i8RQ
// module chunks = 0